module.exports = __webpack_public_path__ + "static/media/img-3.c03ab73f.png";